<ul class="app-periodical-years-layout-wrapper">
  <li *ngFor="let item of periodicalService.yearItems">
    <app-periodical-years-item [item]="item"></app-periodical-years-item>
  </li>
</ul>